module.exports = __webpack_public_path__ + "images/emoji/hospital.86d7498f865d9384cdf8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/hospital.png
// module id = MLMW
// module chunks = 13